import { spacing } from './_spacing';

const gap = spacing['spacing-3'];

//SI SE AGREGA UN NUEVO BREAKPOINT HAY QUE AGREGAR LA FUNCION DE MEDIA QUERY PARA ESE NUEVO BREAKPOINT
export const breakpoints = {
  xxs: {
    size: '0px',
    columns: 4,
    gap: gap,
  },
  xs: {
    size: '768px',
    columns: 8,
    gap: gap,
  },
  s: {
    size: '1024px',
    columns: 8,
    gap: gap,
  },
  m: {
    size: '1280px',
    columns: 12,
    gap: gap,
  },
  l: {
    size: '1366px',
    columns: 12,
    gap: gap,
  },
};
